export enum UserGroups {
  ADMIN = "admin",
}
